import { JSX } from 'react';

export interface IContainerItemBlockHeadingProps {
  headingText: string;
  headingLevel: string;
  headingLevelClass: string;
  headingVisuallyHidden: boolean;
}

export default function ContainerItemBlockHeading(props: IContainerItemBlockHeadingProps) {
  const allowedHeadingLevels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  const headingLevel = allowedHeadingLevels.includes(props.headingLevel) ? props.headingLevel : 'h2';
  const HeadingTag = headingLevel as keyof JSX.IntrinsicElements;
  const className = [props.headingLevelClass, props.headingVisuallyHidden ? 'visually-hidden' : ''].filter(Boolean).join(' ');

  if (!props.headingText || !props.headingText.trim()) {
    return null;
  }

  return <HeadingTag className={className}>{props.headingText}</HeadingTag>;
}
